import { useCallback, useEffect, useRef } from 'react';

const subscribers = [];

export default function useOnClickOutside(ref, handler) {
  const initializedRef = useRef(false);

  const listener = useCallback((event) => {
    for (const { ref, handler } of subscribers) {
      if (!ref || !ref.current || ref.current.contains(event.target)) {
        continue;
      }

      handler(event);
    }
  }, []);

  useEffect(() => {
    let shouldDeregister = false;

    if (!initializedRef.current) {
      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);
      initializedRef.current = true;
      shouldDeregister = true;
    }

    if (!subscribers.find((sub) => sub.ref === ref)) {
      subscribers.push({ ref, handler });
    }

    if (shouldDeregister) {
      return () => {
        document.removeEventListener('mousedown', listener);
        document.removeEventListener('touchstart', listener);
      };
    }
  }, [ref, handler, listener]);
}
